import Quizstudentlist from "./ListQuestions/Quizstudentlist";
import Quizsuperadmin from "./ListQuestions/Quizsuperadmin";
import Quizstudentslide from "./ListQuestions/Quizstudentslide";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import postApiCall from "src/server/postApiCall";
import { Toast } from "primereact/toast";
import { Box, Typography, Button, Paper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ErrorIcon from '@mui/icons-material/Error';
import { CModal, CModalBody} from "@coreui/react";

const Assessment = () => {
  const [courseDetail, setCourseDetail] = useState({});
  const [quizShow, setQuizShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const location = useLocation();
  const trainingId = window.location.href.split("?")[1];
  const sectionType = window.location.href.split("?")[2];
  const blendedId = window.location.href.split("?")[4];
  const learningPlanId = window.location.href.split("?")[5];
  const assignmentId = window.location.href.split("?")[6];
  const toast = useRef(null);
  const colorName = localStorage.getItem("ThemeColor") || "";
  const [themes] = useState(colorName);
  const navigate = useNavigate();
  const apiCallMade = useRef(false);

  useEffect(() => {
    const assessmentId = location.state?.assessmentId;
    if (assessmentId && !apiCallMade.current) {
      handleAssessmentProcess(Number(trainingId), assessmentId);
      apiCallMade.current = true;
    } else if (!assessmentId) {
      setLoading(false);
    }
  }, [location.state, trainingId]);

  const handleAssessmentProcess = async (id, assessmentId) => {
    try {
      setLoading(true);
      await addInProgressCourse({ 
        courseId: id,
        assessmentId: assessmentId,
        blendedProgramId: blendedId || "" ,
        learningplanId : learningPlanId || "",
        assignmentId: assignmentId || ""
        });
      await courseDetailApi(id, assessmentId);
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const addInProgressCourse = async (payload) => {
    try {
      await postApiCall("addInProgressCourse", payload);
    } catch (error) {
      const errMsg =
        error?.response?.data?.error || "Failed to add in-progress course";
      throw new Error(errMsg);
    }
  };

  const courseDetailApi = async (id, assessmentId) => {
    try {
      const payload = {
        courseId: id,
        assessmentId: assessmentId,
        questionSerial: 1,
        studentAnswers: [],
        blendedProgramId: blendedId || "",
        learningplanId : learningPlanId || "",
        assignmentId: assignmentId || ""
      };

      const res = await postApiCall(
        "getStudentAssessmentQuestions",
        payload,
        "application/json"
      );

      if (res?.status === false) {
        // API returned error → show in Box
        setErrorMessage(res?.Message || "An error occurred");
        return;
      }

      setCourseDetail(res);
      setQuizShow(true);
    } catch (err) {
      const errMsg =
        err?.response?.data?.Message ||
        err?.response?.data?.error ||
        "An unexpected error occurred";

      setErrorMessage(errMsg);
    }
  };

  const handleError = (err) => {
    setErrorMessage(err.message || "An unexpected error occurred");
  };

  const renderQuizComponent = () => {
    if (sectionType === "1") {
      return <Quizsuperadmin detail={courseDetail} sectionType={sectionType} />;
    } else if (sectionType === "2") {
      return <Quizsuperadmin detail={courseDetail} sectionType={sectionType} />;
    } else if (courseDetail.displayType === 0) {
      return (
        <Quizstudentslide detail={courseDetail} sectionType={sectionType} />
      );
    } else {
      return (
        <Quizstudentlist detail={courseDetail} sectionType={sectionType} />
      );
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "85vh",
          fontSize: 18,
        }}
      >
        Loading assessment...
      </div>
    );
  }

  return (
    <div>
      <Toast ref={toast} />

      {quizShow ? (
        <CModal visible={quizShow} fullscreen>
           <CModalBody style={{ padding: 0, backgroundColor:"#202020" }}>{renderQuizComponent()}</CModalBody>
        </CModal>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="85vh"
          bgcolor="white"
        >
          <Paper
            elevation={0}
            sx={{
              p: 4,
              maxWidth: 700,
              textAlign: "center",
              border: "none",
            }}
          >
            <ErrorIcon style={{ fontSize: 100, color: "#f44336" }} />
            <Typography variant="h5" color="text.secondary" gutterBottom>
              {errorMessage ? "Assessment Unavailable" : "No assessment available"}
            </Typography>

            <Typography
              variant="h6"
              color={errorMessage ? "error.main" : "text.disabled"}
              mb={3}
            >
              {errorMessage || "The assessment could not be found or failed to load."}
            </Typography>

            <Button
              className={`btn saveButtonTheme${themes}`}
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                px: 3,
              }}
            >
              Go Back
            </Button>
          </Paper>
        </Box>
      )}
    </div>
  );
};

export default Assessment;
